import { size, colors, mediaQueries } from '@everlywell/leaves';
import styled from 'styled-components';

type ContainerProps = {
  /** Height to be used for each slide, this is a workaround because swiper
   * is setting the height of the slide to the same height of all slides */
  height: number | undefined;
  /** Based on the designs the height of the numbers is the height of the
   * image and not the height of the slide */
  numbersHeight: number | undefined;
};

export const Container = styled.div<ContainerProps>`
  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .numbered-swiper {
    display: flex;

    ${mediaQueries.forTabletVerticalUp} {
      align-items: center;
    }

    &-pagination {
      width: ${size.xl1}px;
      margin-right: ${size.md}px;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      min-height: 200px;
      height: ${({ numbersHeight }) =>
        numbersHeight ? `${numbersHeight}px` : '100%'};
      z-index: 1;
    }

    /* Following classes are generated by swiper */
    .swiper {
      &-wrapper {
        height: ${({ height }) => (height ? `${height}px` : null)};
      }
      &-container {
        ${mediaQueries.forTabletVerticalUp} {
          height: unset;
          z-index: 0;
        }
      }

      &-pagination {
        &-bullet {
          flex: 1;
          border-left: 1.5px solid ${colors.green5};
          background-color: ${colors.white};
          color: ${colors.green5};
          border-radius: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          &-active {
            border-color: ${colors.green5};
            transition: opacity 0.5s ease-in-out;
          }
        }
      }
    }
  }
`;
